import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocationDetailsSession } from "../../api/models/locationDetailsSession";
import { ApiErrorCode, ServiceURLConstants } from "../../constants/upplm.constants";
import { DAYS_SHORTCODE_DAYWEEK, PICKUP_TYPE, PICKUP_TYPE_PLAN } from "../../constants/upplm.constants.pickupdetails";
import { AvailableDaysAndServicesSelected, GetPickupScheduleDetailsRequest, PickupScheduleDetailResponse, PickupType, PickupTypePlan } from "../../interface/upplm.pickupdetails";
import { PickupDetailsEditSession } from "../../interface/upplm.pickupdetails.edition";
import { PickupDetails, SelectedDays } from "../../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../../pipes/translation.pipe";
import { UpsCommonService } from "../upplm.common.service";

@Injectable()

export class PickupDetailsHelperService {;
    
    constructor(private _commonService: UpsCommonService,
        private _http: HttpClient,
        private _translateData: TranslateDataPipe) {
    }

    getCurrentPickupDetailsValues(pickupDetails: PickupDetails): PickupDetailsEditSession {
        let pickupDetailsSession = new PickupDetailsEditSession();
        pickupDetailsSession.pickupType = pickupDetails.pickupPlanType;
        pickupDetailsSession.selectedDays = pickupDetails.selectedDays;
        pickupDetailsSession.pickupComesFromLocation = false;
        return pickupDetailsSession;
    }

    async getAvailableDaysAndServices(request: GetPickupScheduleDetailsRequest): Promise<PickupScheduleDetailResponse> {
        let url = this._commonService.createURL(ServiceURLConstants.GET_UPPLM_PICKUP_DETAILS, ApiErrorCode.GET_UPPLM_PICKUP_DETAILS);
        return this._http.post<any>(url, request).toPromise();

    }

    getPickupScheduleDetailsRequest(locationDetailsSession: LocationDetailsSession): GetPickupScheduleDetailsRequest {
        let request = new GetPickupScheduleDetailsRequest();
        request.address.AddressLine1 = locationDetailsSession.address1;
        request.address.AddressLine2 = locationDetailsSession.address2;
        request.address.CityTown = locationDetailsSession.city;
        request.address.StateProvince = locationDetailsSession.state;
        request.address.CountryCode = locationDetailsSession.countryKey;
        request.address.PostalCode = locationDetailsSession.postal;
        request.clientKey = locationDetailsSession.clientKey;
        request.preferredOptions = null;
        return request;
    }

    getPickupTypeDescription(pickupTypes: PickupTypePlan[]): PickupType[] {
        let result: PickupType[] = [];
        pickupTypes.forEach(function (pickup) {
            let pickupType: PickupType = {
                id: pickup.pickupPlanType,
                description: this._translateData.transform(PICKUP_TYPE_PLAN.find(x => x.id === pickup.pickupPlanType).translatedDescription.toString())
            };
            result.push(pickupType);
        }, this);
        return result;
    }

    getPickupTypeSelection(pickupType: string): string {
        if (pickupType.toUpperCase() === "DAY_SPECIFIC") return PICKUP_TYPE.DSP;
        if (pickupType.toUpperCase() === "DAILY") return PICKUP_TYPE.DAP;
        if (pickupType.toUpperCase() === "SMART") return PICKUP_TYPE.SMP;
        return '';
    }

    getPreferredServicesFromSelectedDays(selectedDays: SelectedDays[]): AvailableDaysAndServicesSelected[] {
        let preferredDays: AvailableDaysAndServicesSelected[] = [];
        selectedDays.forEach(selectedDay => {
            let preferredDay = new AvailableDaysAndServicesSelected();
            preferredDay.dayOfWeekCode = DAYS_SHORTCODE_DAYWEEK.find(daycode => daycode.dayshortcode === selectedDay.dayOfWeekCode).key;
            preferredDay.selectedLatestTime = this.getRawTime(selectedDay.selectedLatestTime);
            preferredDay.selectedPreferredTime = this.getRawTime(selectedDay.selectedPreferredTime);
            preferredDays.push(preferredDay);
        });
        return preferredDays;
    }

    getRawTime(formattedTime: string): string {
        // Time is received as 03:30 PM -> 15:30 || 11:30 AM -> 11:30
        let timeWithoutIndicator = formattedTime.substring(0, formattedTime.length - 3);
        let rawTimeSplitted = timeWithoutIndicator.substring(0, formattedTime.length - 3).split(':');

        if (formattedTime.includes('PM') || formattedTime.includes('pm')) {
            if (parseInt(rawTimeSplitted[0]) < 12) {
                return `${parseInt(rawTimeSplitted[0]) + 12}:${rawTimeSplitted[1]}`;
            } else {
                return `${parseInt(rawTimeSplitted[0])}:${rawTimeSplitted[1]}`;
            }
        } else {
            return timeWithoutIndicator;
        }
    }

    public areGreaterForMinutes(formattedTime1: string, formattedTime2: string): boolean {
        let time1 = parseInt(this.getRawTime(formattedTime1).substring(3));
        let time2 = parseInt(this.getRawTime(formattedTime2).substring(3));
        return (time1 >= time2);
    }
}